import React, {useState, useEffect} from 'react';
import K from '../k';
import icons from '../assets/icons/';

/**
 * The Icon component is intended for three different use-cases in which the user passes one
 * of the following props.
 *
 * @param name string | ImgSrc, refer to ./src/assets/icons/ to view icon names
 * @param icon ReactNode
 * @param src img source
 */
const Icon = ({src, icon, name, theme = 'black', style, strokeWidth, onClick, ...rest}) => {
  const [iconSrc, setIconSrc] = useState(src);

  const styles = {
    icon: {
      objectRepeat: 'no-repeat',
      objectPosition: 'center',
      ...(onClick ? {cursor: 'pointer'} : {}),
      ...K.defaultIconSize,
      ...style,
    }
  };

  useEffect(() => {
    if (name) {
      setIconSrc(icons[`${name}${strokeWidth ? strokeWidth : ''}`][theme]);
    }
  }, [name, theme]);

  return (<>
    {icon ? icon : <img {...{onClick}} draggable={false} src={iconSrc} style={styles.icon} {...rest} />}
  </>);
};

export default Icon;